export const SPECS = {
  CustomProductUrlInCartOOI: 'specs.stores.CustomProductUrlInCartOOI',
  CashierExpressNavigateToThankYouPageWhen1ShippingMethod:
    'specs.stores.CashierExpressNavigateToThankYouPageWhen1ShippingMethod',
  DisplayPickupInTotalSummary: 'specs.stores.DisplayPickupInTotalSummary',
} as const;
